<div mat-dialog-title>
 <h4 class="modal-title text-start">{{'xm-balance.balance-detail-dialog.title' | translate}}</h4>
  <xm-modal-close mat-dialog-close></xm-modal-close>
</div>
<div mat-dialog-content>
  <div *ngIf="pockets?.length" class="table-responsive">
    <table class="table table-striped">
      <thead>
      <tr>
        <th scope="col"><span>{{'xm-balance.common.fields.label' | translate}}</span></th>
        <th scope="col"><span>{{'xm-balance.common.fields.start-date' | translate}}</span></th>
        <th scope="col"><span>{{'xm-balance.common.fields.end-date' | translate}}</span></th>
        <th scope="col"><span>{{'xm-balance.common.fields.amount' | translate}}</span></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let pocket of pockets">
        <td>
          {{pocket.label}}
        </td>
        <td>
          {{pocket.startDateTime | date:'yyyy-MM-dd HH:mm'}}
        </td>
        <td>
          {{pocket.endDateTime | date:'yyyy-MM-dd HH:mm'}}
        </td>
        <td>
          {{pocket.amount}}
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <no-data [show]="!pockets?.length"></no-data>
</div>
<div mat-dialog-actions>
  <button class="ms-auto"
          mat-flat-button
          data-dismiss="modal"
          type="button"
          (click)="onCancel()">
    {{'xm-balance.common.cancel' | translate}}
  </button>
</div>
